import { MarkdownView } from '@platform/engine/fields/markdown/MarkdownView';
import type { IAiMessageBubbleProps } from './IAiMessageBubbleProps';

/**
 * Бульбашка розмови (прототип v4 G:L3528): питання користувача — праворуч на акцентному тлі, як є (pre-wrap); відповідь асистента —
 * ліворуч на --surface2, Markdown (заголовки, списки, таблиці, код, посилання на записи — безпечний рендер без HTML, patterns/ai-assistant).
 */
export function AiMessageBubble({ message, ws }: IAiMessageBubbleProps) {
  if (message.role === 'user') return <div className="ai-panel__msg is-user">{message.text}</div>;
  return (
    <div className="ai-panel__msg is-assistant">
      <MarkdownView text={message.text} ws={ws} className="ai-panel__md" />
    </div>
  );
}
